import { Box, Tooltip } from '@mui/material';
import DefaultLogo from '@shared/assets/air/iconBlack.png';
import { convertToCamelCase } from '@shared/helpers';

const RenderAirline = ({ object_option }) => {
  const airline = object_option?.flights?.[0]?.airline || {};
  const airlineName = convertToCamelCase(
    airline.description || airline.code || ''
  );

  return (
    <Tooltip
      title={airlineName}
      arrow
      placement="top"
      PopperProps={{
        disablePortal: true,
      }}
    >
      <Box
        component="img"
        src={object_option?.airlines?.[0]?.logo || DefaultLogo}
        alt="aerolínea"
        sx={{
          width: 35, // tamaño base
          height: 35,
          objectFit: 'contain',
          cursor: 'pointer',
          transform: { xs: 'scale(0.75)', sm: 'scale(1)' }, // responsive
          transformOrigin: 'center', // escala desde el centro
          transition: 'transform 0.2s',
        }}
      />
    </Tooltip>
  );
};

export default RenderAirline;
